import React from "react";
import Reveal from "@/components/Reveal";

// Authority strip — restrained, consulting-firm style credential row.
// Four trust points, divided columns, no cards or checkmark clusters.
const POINTS = [
  { title: "Registered NDIS Provider", sub: "Registered with the NDIS Quality and Safeguards Commission" },
  { title: "Occupational Therapist-Led", sub: "Assessments completed by AHPRA-registered Occupational Therapists" },
  { title: "Clinical Peer Review", sub: "Every FCA reviewed prior to issue" },
  { title: "Australia-Wide", sub: "Telehealth assessments across all states and territories" },
];

export default function TrustStrip() {
  return (
    <section className="bg-white border-y border-stone-200/80" data-testid="trust-strip" aria-label="Practice credentials">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 lg:py-10">
        <Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-6 lg:gap-x-10 lg:divide-x lg:divide-stone-200">
            {POINTS.map((p, i) => (
              <div key={p.title} className={`lg:px-8 ${i === 0 ? "lg:pl-0" : ""} ${i === POINTS.length - 1 ? "lg:pr-0" : ""}`} data-testid={`trust-${i}`}>
                <div className="font-display text-[15.5px] font-semibold text-[#1C1917] leading-snug">{p.title}</div>
                <div className="mt-1.5 text-[13px] text-[#57534E] leading-snug">{p.sub}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
